import React from 'react';
import { Link } from 'gatsby';
import { FaUserFriends, FaBed, FaBath } from 'react-icons/fa';
import {
  getLocalisationFromPropertyObject,
  getCorrectPropertyObject,
} from '../utils';
import Image from './Image';

const VariableLink = ({ children, propertyLink, state, isExternal }) => {
  if (!!isExternal) {
    return (
      <a href={propertyLink} target='_blank' rel='noopener noreferrer'>
        {children}
      </a>
    );
  }
  return (
    <Link to={propertyLink} state={state}>
      {children}
    </Link>
  );
};

const PropertiesRoll = ({
  properties,
  bookingData,
  propertySearch,
  propertyObject,
  icons,
}) => {
  const renderProperties = (propertiesArray) => {
    if (propertiesArray.length) {
      return propertiesArray;
    }
    return (
      <div className='content container'>
        <h2 align='center' className='no-properties'>
          {propertySearch.noMatch}
        </h2>
      </div>
    );
  };

  const mappedProperties = properties.map((property) => {
    const iconImage = () => {
      switch (property.node.frontmatter.serviceType) {
        case 'Luxury':
          return icons.luxury;
        case 'HakuLife':
          return icons.hakuLife;
        case 'Signature':
        default:
          return icons.signature;
      }
    };
    const isExternal = !!property.node.frontmatter.externalPropertyLink;
    const propertyLink = isExternal
      ? property.node.frontmatter.externalPropertyLink
      : `${getLocalisationFromPropertyObject(propertyObject)}${
          property.node.fields.slug
        }`;

    const renderAwards = () => {
      if (!!property.node.frontmatter.awards) {
        return property.node.frontmatter.awards.map((award) => {
          return <Image imageInfo={{ image: award.image }} />;
        });
      }
      return null;
    };

    const getServiceTranslation = (service) => {
      if (propertyObject === 'property_data_jp') {
        if (service === "HakuLife") {
          return "ハク";
        }
        if (service === "Signature") {
          return "シグネチャー";
        }
        return "ラグジュアリー";
      }
      if (propertyObject === 'property_data_zhhans') {
        if (service === "HakuLife") {
          return "白鸟生活";
        }
        if (service === "Signature") {
          return "签名";
        }
        return "奢华";
      }
      return service;
    }

    const getPriceTier = () => {
      if (property.node.frontmatter.serviceType === "Signature") {
        return "¥¥"
      } 

      if (property.node.frontmatter.serviceType === "Luxury") {
        return "¥¥¥"
      }
      
      if (property.node.frontmatter.serviceType === "HakuLife") {
        return "¥P.O.A"
      } 
    }
    const renderPropertyPrice = () => {     
      return (
        <span className={ `property-roll-price ${property.node.frontmatter.serviceType}` }>
          {`${getPriceTier()} | ${property.node.frontmatter.serviceType}`}
        </span>
      );
    };

    return (
      <div className='column is-4' key={property.node.frontmatter.title}>
        <div className='property-roll-image-container'>
          <VariableLink
            isExternal={isExternal}
            propertyLink={propertyLink}
            state={{
              bookingData,
              price: property.node.frontmatter.startingPrice,
            }}>
            <div className={`service-icon-container ${property.node.frontmatter.serviceType === "HakuLife" ? 'haku-life-icon' : ''}`}>
              <Image imageInfo={{ image: iconImage() }} />
            </div>
            <div className={`award-icon-container`}>{renderAwards()}</div>
            <Image
              imageInfo={{ image: property.node.frontmatter.featuredImage }}
              classes='property-roll-image'
              animationClass='hover-zoom'
            />
            <div className='property-listing-description'>
              <span className='property-icon'>
                <FaUserFriends /> {property.node.frontmatter.maxGuests}{' '}
              </span>
              <span className='property-icon'>
                <FaBed />{' '}
                {getCorrectPropertyObject(
                  property.node.frontmatter,
                  propertyObject
                ).bedrooms.replace(/[^\d-&.]/g, '')}{' '}
              </span>
              <span className='property-icon'>
                <FaBath />{' '}
                {getCorrectPropertyObject(
                  property.node.frontmatter,
                  propertyObject
                ).bathrooms.replace(/[^\d-&.]/g, '')}
              </span>
              {property.node.frontmatter.allNiseko ? (
                <div className='property-anp'>
                  <Image
                    imageInfo={{ image: icons.allNiseko }}
                    classes='property-anp-icon'
                  />
                </div>
              ) : null}
              {renderPropertyPrice()}
              
            </div>
            <div className="property-title-wrapper">
              <h4 className='title'>{getCorrectPropertyObject(property.node.frontmatter, propertyObject).title || property.node.frontmatter.title }</h4>
              <span>{getCorrectPropertyObject(
                    property.node.frontmatter,
                    propertyObject
                ).location}</span>
            </div>
          </VariableLink>
        </div>
      </div>
    );
  });
  return (
    <div className='container content'>
      <div className='columns is-variable is-6 is-multiline'>
        {renderProperties(mappedProperties)}
      </div>
    </div>
  );
};

export default PropertiesRoll;
